import dayjs from 'dayjs';

// used by SingleSaasRolePage and friends
export const privileges = {
  high: 'hpu',
  some: 'pu',
  none: 'u'
}

export const displayTitleForEnabledUsers = 'User'

// used by SaasStore - could be used more widely
// These are the exact strings used in the database
export const privilegeStrings = {
  highlyPrivileged: 'Highly Privileged User',
  privileged: 'Privileged User',
  enabled: 'User',
}

const privilegeStringFromCodeLookup: any = {
  hpu: privilegeStrings.highlyPrivileged,
  pu: privilegeStrings.privileged,
  u: privilegeStrings.enabled,
}

export const privilegeStringFromCode = (
  privilegeCode?: keyof typeof privilegeStringFromCodeLookup | null
) => {
  let result;
  if (typeof privilegeCode === 'string') {
    result = privilegeStringFromCodeLookup[privilegeCode];
  }
  return result;
}

export const lastLoginColumnLabel = 'Last Login';

export const driftFromDefault = () => dayjs()
  .subtract(
    28, // isLocalhost() ? 100 : 28,
    'day'
  )
  .format('YYYY-MM-DDTHH:mm:ss');

export const stringForMissingUserName = 'missing name';
export const stringForMissingText = '-'

// these values come from the back end
export const userStatusStrings = {
  enabled: 'Enabled',
  disabled: 'Disabled',
  deleted: 'Deleted',
}

export const daysToInactiveStatus = 60

export const oneMinute = 60 * 1000;
export const oneHour = 60 * oneMinute;
export const oneDay = 24 * oneHour;

export const wordForChange = 'drift';

export const wordForFederated = 'Yes';
export const wordForUnfederated = 'No';

export const logoWithNamePath = process.env.PUBLIC_URL + '/logoWithName.png'

export const tableCellHeadings = {
  saas : 'SaaS Name',                     // SaaS
  application: 'Application Name',        // User app
}

export const portalUserRoles = {
  admin: "admin",
  orgAdmin: "org_admin",
  user: "user",
}

// Every client is on the single unlimited licence; this is the plan_type the
// backend still expects on client writes.
export const unlimitedPlanType = "unlimited"

export const localPasswordConnection = 'Username-Password-Authentication';